<template>
    <Modal modalWidth="800px" class="" @close="$emit('close')">
        <template #modalHeader>
            <h2><span>Aggiungi regola</span></h2>
        </template>
        <template #modalBody>
            <div class="modal-body">
                <!-- RULE NAME -->
                <TextFieldEnh
                    id="rulename"
                    name="rulename"
                    label="Nome regola"
                    placeholder="nome regola"
                    v-model:modelValue="ruleRef.name"
                    :required="true"
                    @update:modelValue="errors.name = false"
                    :error="errors.name"
                    errorMessage="campo obbligatorio"
                    class="mb-4"
                ></TextFieldEnh>
                <!-- CHARACTERISTIC -->
                <DropdownList
                    id="rulefeature"
                    name="rulefeature"
                    label="Caratteristica"
                    placeholder="selezionare ..."
                    v-model:value="ruleRef.feature"
                    :options="ruleFeatures"
                    :multiple="false"
                    :required="true"
                    @update:value="handleFeatureUpdate"
                    :error="errors.feature"
                    errorMessage="campo obbligatorio"
                ></DropdownList>
                <fieldset class="border-2 p-4">
                    <legend class="text-sm font-bold text-gray-900">Condizione</legend>
                    <!-- SUBJECT -->
                    <!-- v-if="ruleRef.feature !== 'assign'" -->
                    <DropdownList
                        id="rulesubject"
                        name="rulesubject"
                        label="Campo"
                        placeholder="selezionare ..."
                        v-model:value="ruleRef.subject"
                        :options="ruleSubjects"
                        :multiple="false"
                        :required="true"
                        @update:value="
                            errors.subject = false;
                            ruleRef.operator = null;
                            ruleRef.value = null;
                        "
                        :error="errors.subject"
                        errorMessage="campo obbligatorio"
                    ></DropdownList>
                    <!-- OPERATOR -->
                    <DropdownList
                        id="ruleoperator"
                        name="ruleoperator"
                        label="Operatore"
                        placeholder="selezionare ..."
                        v-model:value="ruleRef.operator"
                        :options="ruleOperators"
                        :multiple="false"
                        :required="true"
                        @update:value="
                            errors.operator = false;
                            console.log('UPDATE OPERATOR', ruleRef.operator);
                        "
                        :error="errors.operator"
                        errorMessage="campo obbligatorio"
                    ></DropdownList>
                    <!-- VALUE -->
                    <TextFieldEnh
                        v-if="isRuleValueVisible == true && ruleRef.operator != 'in'"
                        id="rulevalue"
                        name="rulevalue"
                        label="Valore"
                        placeholder="valore"
                        v-model:modelValue="ruleRef.value"
                        :required="true"
                        @update:modelValue="errors.value = false"
                        :error="errors.value"
                        errorMessage="campo obbligatorio"
                    ></TextFieldEnh>
                    <!-- VALUES FOR IN OPERATOR -->
                    <span class="field-label" v-if="ruleRef.operator == 'in'">Valore</span>
                    <div class="flex flex-col gap-2" v-if="ruleRef.operator == 'in'">
                        <div class="flex flex-row flex-nowrap justify-between gap-2">
                            <TextFieldEnh
                                id="rulevalueslist"
                                name="rulevalueslist"
                                label=""
                                placeholder="valore"
                                v-model:modelValue="ruleRef.value"
                                :required="false"
                                @update:modelValue="errors.value = false"
                                :error="errors.value"
                                errorMessage="campo obbligatorio"
                            ></TextFieldEnh>
                            <button class="btn-add self-end flex justify-center items-center" type="button" @click.stop="addValue">
                                <img class="inline-block icon-compact" src="/assets/icons/buttonAddRound.svg" />
                            </button>
                        </div>
                        <div class="flex flex-col flex-nowrap p-2 border rounded" :class="{ 'border-error-dark': errors.valueslist }">
                            <div
                                v-for="(value, index) in ruleRef.valueslist"
                                :key="index"
                                class="flex items-center justify-between gap-2"
                            >
                                <span>{{ value }}</span>
                                <button
                                    class="btn-close w-14 self-end flex justify-center items-center"
                                    type="button"
                                    @click.stop="removeValue(index)"
                                >
                                    <img class="inline-block icon-compact" src="/assets/icons/delete.svg" />
                                </button>
                            </div>
                            <span v-if="!ruleRef.valueslist?.length">Nessun valore inserito</span>
                        </div>
                        <div v-if="errors.valueslist" class="mt-1 text-xs/4 text-error-dark">Inserire almeno un valore</div>
                    </div>
                </fieldset>
                <fieldset v-if="ruleRef.feature === 'assign'" class="border-2 p-4">
                    <legend class="text-sm font-bold text-gray-900">Assegna valore</legend>
                    <!-- DESTINATION SUBJECT -->
                    <!-- <DropdownList
                        id="ruledestination"
                        name="ruledestination"
                        label="Campo destinazione"
                        placeholder="selezionare ..."
                        v-model:value="ruleRef.destination"
                        :options="ruleDestination"
                        :multiple="false"
                        :required="true"
                        @update:value="
                            errors.destination = false;
                            ruleRef.operator = null;
                        "
                        :error="errors.destination"
                        errorMessage="campo obbligatorio"
                    ></DropdownList> -->
                    <!-- VALUE -->
                    <TextFieldEnh
                        v-if="
                            formEditorStore.getWidgetValueTypeByName(ruleRef.destination) &&
                            formEditorStore.getWidgetValueTypeByName(ruleRef.destination) != 'bool' &&
                            formEditorStore.getWidgetValueTypeByName(ruleRef.destination) != 'data'
                        "
                        id="ruledestinationvalue"
                        name="ruledestinationvalue"
                        label="Valore"
                        placeholder="valore"
                        v-model:modelValue="ruleRef.destinationvalue"
                        :required="true"
                        @update:modelValue="errors.destinationvalue = false"
                        :error="errors.destinationvalue"
                        errorMessage="campo obbligatorio"
                    ></TextFieldEnh>
                </fieldset>
            </div>
        </template>
        <template #modalFooter>
            <button class="btn-close self-end" type="button" @click.stop="$emit('close')">Annulla</button>
            <button v-if="props.ruleIndex === false" class="btn-add self-end" type="button" @click.stop="addRule">Aggiungi</button>
            <button v-if="props.ruleIndex !== false" class="btn-add self-end" type="button" @click.stop="saveRule">Salva</button>
        </template>
    </Modal>
</template>

<script setup>
import _ from 'lodash';

import { computed, ref } from 'vue';
import { useVModel } from '@vueuse/core';

import { features, operators } from '../../data/rules.js';

import { useFormEditorStore } from '../../stores/formEditorStore';

import Modal from '../lib/Modal.vue';
import TextFieldEnh from '../lib/TextFieldEnh.vue';
import DropdownList from '../lib/DropdownList.vue';

const props = defineProps({
    widget: {
        type: Object,
        required: true,
    },
    ruleIndex: {
        type: [Boolean, Number],
        required: true,
    },
    rules: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['update:rules', 'close']);
const rulesRef = useVModel(props, 'rules', emit);

const formEditorStore = useFormEditorStore();

let ruleRef;
ruleRef = ref({
    name: props.ruleIndex !== false ? rulesRef.value[props.ruleIndex].name : null,
    feature: props.ruleIndex !== false ? rulesRef.value[props.ruleIndex].feature : null,
    subject: props.ruleIndex !== false ? rulesRef.value[props.ruleIndex].subject : null,
    operator: props.ruleIndex !== false ? rulesRef.value[props.ruleIndex].operator : null,
    value: props.ruleIndex !== false ? rulesRef.value[props.ruleIndex].value : null,
    valueslist: props.ruleIndex !== false ? rulesRef.value[props.ruleIndex].valueslist : null,
    destination: props.ruleIndex !== false ? rulesRef.value[props.ruleIndex].destination : null,
    destinationvalue: props.ruleIndex !== false ? rulesRef.value[props.ruleIndex].destinationvalue : null,
});
const errors = ref({
    name: false,
    feature: false,
    subject: false,
    operator: false,
    value: false,
    valueslist: false,
    destination: false,
    destinationvalue: false,
});

const isFormValid = () => {
    Object.keys(ruleRef.value).forEach((key) => {
        errors.value[key] = false;
        if (!ruleRef.value[key] || ruleRef.value[key] == false) {
            errors.value[key] = true;
        } else if (ruleRef.value[key]?.length == 0) {
            errors.value[key] = true;
        }
    });
    // se l'errore e' sul campo value allora gestisci i casi particolari ...
    if (errors.value['value']) {
        if (
            ruleRef.value.operator == 'is-checked' ||
            ruleRef.value.operator == 'is-not-checked' ||
            ruleRef.value.operator == 'selected' ||
            ruleRef.value.operator == 'not-selected'
        ) {
            errors.value['value'] = false;
        }
    }
    if (!errors.value['feature'] && ruleRef.value.feature !== 'assign') {
        if (errors.value['destinationvalue'] || errors.value['destination']) {
            errors.value['destinationvalue'] = false;
            errors.value['destination'] = false;
        }
    }
    if (!errors.value['operator']) {
        if (ruleRef.value.operator == 'in') {
            if (errors.value['value']) {
                // azzera l'errore cosi' da visualizzare il messaggio solo sulla lista
                errors.value['value'] = false;
            }
        } else {
            if (errors.value['valueslist']) {
                errors.value['valueslist'] = false;
            }
        }
    }
    if (Object.keys(errors.value).every((key) => errors.value[key] === false)) return true;
    return false;
};

const addValue = () => {
    if (ruleRef.value.value) {
        if (!ruleRef.value.valueslist) {
            ruleRef.value.valueslist = [];
        }
        ruleRef.value.valueslist.push(ruleRef.value.value);
        ruleRef.value.value = null;
        errors.value.value = false;
        errors.value.valueslist = false;
    }
};

const removeValue = (index) => {
    ruleRef.value.valueslist.splice(index, 1);
};

const addRule = () => {
    if (isFormValid()) {
        rulesRef.value.push(ruleRef.value);
        emit('close');
    }
};

const saveRule = () => {
    if (isFormValid()) {
        rulesRef.value.splice(props.ruleIndex, 1, ruleRef.value);
        emit('close');
    }
};

const wouldCreateCycle = (subject, destination) => {
    const visited = new Set();

    const dfs = (currentNodeName) => {
        // Se troviamo il nodo sorgente, abbiamo un ciclo
        if (currentNodeName === subject) {
            return true;
        }

        visited.add(currentNodeName);

        const currentNode = formEditorStore.getWidgetByName(currentNodeName);
        for (const rule of currentNode.instanceProperties.rules) {
            // Se il nodo riferito è già stato visitato, saltiamo
            if (rule.feature == 'assign' && visited.has(rule.subject)) {
                continue;
            }

            // Se troviamo un ciclo nei riferimenti successivi
            if (dfs(rule.subject)) {
                return true;
            }
        }

        return false;
    };

    return dfs(destination);
};

const ruleSubjects = computed(() => {
    // elenco widget (ok per select) senza la root e senza il campo a cui si sta aggiungendo la regola
    let r = _.reduce(
        formEditorStore.formDefIndex,
        (carry, widgetDef) => {
            if (widgetDef.classProperties.type == 'form-widget') {
                if (widgetDef.instanceProperties.name != props.widget.instanceProperties.name) {
                    carry.push({
                        label: widgetDef.instanceProperties.name,
                    });
                }
            }
            return carry;
        },
        []
    );
    // se sto aggiungendo una regola di assign rimuovo i campi che possono creare un reference circolare di assegnazioni
    if (ruleRef.value.feature == 'assign') {
        r.forEach((widgetName) => {
            if (wouldCreateCycle(ruleRef.value.destination, widgetName.label)) {
                widgetName.disabled = true;
            }
        });
    }
    return r;
});

// const ruleDestination = computed(() => {
//     return _.reduce(
//         formEditorStore.formDefIndex,
//         (carry, widgetDef) => {
//             if (widgetDef.classProperties.valueType == 'data') {
//                 return carry;
//             }
//             if (widgetDef.classProperties.type == 'form-widget') {
//                 if (widgetDef.instanceProperties.name != props.widget.instanceProperties.name) {
//                     carry.push({
//                         label: widgetDef.instanceProperties.name,
//                     });
//                 }
//             }
//             return carry;
//         },
//         []
//     );
// });

const ruleOperators = computed(() => {
    let subjectValueType, subjectIsNumeric, subjectIsDate;

    console.log('RULE OPERATORS');

    if (ruleRef.value.feature == 'assign') {
        subjectValueType = formEditorStore.getWidgetValueTypeByName(ruleRef.value.subject);
        if (subjectValueType == 'one-number') {
            subjectValueType = 'one';
        }

        subjectIsNumeric = formEditorStore.isNumericWidget(ruleRef.value.subject);
        subjectIsDate = formEditorStore.isDateWidget(ruleRef.value.subject);
    } else {
        if (ruleRef.value.subject == null) {
            return [];
        }
        subjectValueType = formEditorStore.getWidgetValueTypeByName(ruleRef.value.subject);
        if (subjectValueType == 'one-number') {
            subjectValueType = 'one';
        }

        subjectIsNumeric = formEditorStore.isNumericWidget(ruleRef.value.subject);
        subjectIsDate = formEditorStore.isDateWidget(ruleRef.value.subject);
    }
    let r = _.filter(operators, (operator) => {
        if (operator.type == subjectValueType) {
            return true;
        }
        return false;
    });
    if (!subjectIsNumeric && !subjectIsDate) {
        r = _.filter(r, (operator) => {
            if (['greater-than', 'greater-or-equal-than', 'less-than', 'less-or-equal-than'].includes(operator.value)) {
                return false;
            }
            return true;
        });
    }
    return r;
});

const ruleFeatures = computed(() => {
    return features;
});

const handleFeatureUpdate = (value) => {
    errors.value.feature = false;
    console.log('HANDLE FEATURE UPDATE', value);
    if (value == 'assign') {
        ruleRef.value.destination = props.widget.instanceProperties.name;
    } else {
        ruleRef.value.destination = null;
    }
};

const isRuleValueVisible = computed(() => {
    const r =
        ruleRef.value.subject &&
        (_.isArray(ruleRef.value.subject) ? ruleRef.value.subject.length : true) &&
        formEditorStore.getWidgetValueTypeByName(ruleRef.value.subject) != 'bool' &&
        formEditorStore.getWidgetValueTypeByName(ruleRef.value.subject) != 'data';
    return !!r;
});
</script>

<style lang="postcss" scoped>
.modal-body {
    height: auto;
}
</style>
